// Read-only consumers of the Disease Code Management feature (PRD 08). The
// Item detail panel uses these for the two conditional Scope dropdowns:
//   - scope === 'DISEASE_GROUP'    → useDiseaseGroups() dropdown.
//   - scope === 'DISEASE_SPECIFIC' → useDiseaseCodesAll() dropdown.
//
// We do NOT add a new endpoint to the disease-code feature; we reuse
// `listGroups` + `listCodes` and fan out in the hook (N+1). For the mock
// dataset this is instant; for production BE should consider exposing a
// `GET /admin/disease-codes` flat list — see open question Q7 in
// docs/api-contracts/pro-item-design.md.

import { useQuery } from '@tanstack/react-query';

import { diseaseCodeApi } from '@/features/disease-code/api/disease-code.adapter';
import type {
  DiseaseCode,
  DiseaseGroup,
} from '@/features/disease-code/types/disease-code.types';

const QK = {
  groups: ['pro-item-design', 'disease-groups'] as const,
  codesAll: ['pro-item-design', 'disease-codes-all'] as const,
};

export function useDiseaseGroups() {
  return useQuery<DiseaseGroup[]>({
    queryKey: QK.groups,
    queryFn: () => diseaseCodeApi.listGroups(),
  });
}

export function useDiseaseCodesAll() {
  return useQuery<DiseaseCode[]>({
    queryKey: QK.codesAll,
    queryFn: async () => {
      const groups = await diseaseCodeApi.listGroups();
      const codeLists = await Promise.all(
        groups.map((g) => diseaseCodeApi.listCodes(g.id)),
      );
      return codeLists.flat();
    },
  });
}
